import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { createToObject } from 'pricing-pages-ui-components/utils/queryParamUtils';
import { useHistory } from 'quartz-routing/react-router';
import { FSC_CONFIGURE } from '../../constants/routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function PublicFscCustomizePlanLink({
  onClick
}) {
  const history = useHistory();
  const destination = createToObject(`/${FSC_CONFIGURE}`);
  const handleClick = event => {
    event.preventDefault();
    onClick();
    history.push(destination);
  };
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    marginBlockStart: "800",
    children: /*#__PURE__*/_jsxs(Text, {
      as: "p",
      marginBlock: "0",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "publicPricingPage.customizePlanLink.description"
      }), ' ', /*#__PURE__*/_jsx(Link, {
        href: history.createHref(destination),
        onClick: handleClick,
        "data-selenium-id": "fsc-customize-plan-link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.customizePlanLink.cta"
        })
      })]
    })
  });
}